const article = {
	slug: "gcp-suspension-ai-security",
	title: "Credential Hygiene Is Not a Threat Model",
	date: "25 May 2026",
	updated: null,
	description:
		"AI removes the friction that used to make you pause and think. Teams get credential hygiene right and still miss the attack surface around the credential, because threat modeling is the question AI never generates.",
	keywords: [
		"AI security",
		"API security",
		"threat modeling",
		"rate limiting",
		"AI engineering",
		"attack surface",
	],
	tldr: "We ship AI faster than we ask what can go wrong. Credential hygiene is the checklist most developers already know. Threat modeling, imagining how code gets used against you, is the part AI does not generate and the gap most teams miss.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, May 2026.",
	provenanceUrl: null,
	series: "ai-governance-for-finserv-leaders",
	artifact: null,
	markdown: `We ship AI faster than we ask what can go wrong.

I found that out the hard way. A project suspended for abusive activity, with no warning.

## The credential work was correct

I had done the credential work correctly. Key in .env, never committed to git, server-side on the host. What I had not done was think about what happens when bots find the endpoint that uses it.

The endpoint stayed public. The attackers didn't need the key. They just needed the URL. My app called the model on their behalf until the provider noticed.

I used AI to build it. I used AI to diagnose it. Neither one asked the adversarial question.

## AI removes the friction that made you pause

The vulnerability is Web Dev 101.

The thing is, traditional coding slows you down enough that you occasionally stop and think. AI removes that friction. You go from idea to deployed endpoint so fast the obvious question never comes up: who else can hit this?

The stakes on a personal build are low. The same blind spot shows up in enterprise production systems, just with a bigger blast radius.

## Threat modeling is the part AI does not generate

When teams build with AI, they tend to get the credential hygiene right. Environment variables in the right places, secrets never committed, input validation where it's obvious. That is the checklist most developers know by heart by now.

What AI does not generate is the question of how that code gets abused. That's threat modeling. It requires imagining how something gets used against you, not just how it gets used for you.

For teams today, doing credential hygiene and calling it done is no longer enough.

That is what I am building toward: an OWASP-oriented skill that prompts for adversarial thinking before a line of security-relevant code gets written.`,
};

export default article;
